import React, { Component } from 'react';
import GenericCard from '../../components/generic-card/generic-card';
import BusinessCaseProduct from './business-case-product';
import { arrayCountByMatch } from '../../app-actions';

class BusinessCaseBuilderView extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      selectAll: false,
    });
  }
  render() {
    const { authorableContent, productRecommendation = [], cidn, divId = 'business-case' } = this.props;
    const { heading, description, subHeading, selectAllSuffixText } = authorableContent;
    const checkBoxSelectedCount = arrayCountByMatch(productRecommendation, 'recommendationSelected', true);

    const numberOfProductsSelected = (
      <ul className="num-products-selected list-group list-group-flush">
        <li className="list-group-item border-bottom-0">
          <div className="select-all-text">
            <span id="bcb-total-products-selected" className="text-muted">({checkBoxSelectedCount}) {selectAllSuffixText}</span>
          </div>
        </li>
      </ul>
    );
    const contentLayout = (
      <React.Fragment>
        {numberOfProductsSelected}
        <div className="list-group list-group-flush product-layout">
          {
            productRecommendation.map(productData => (
              <BusinessCaseProduct
                cidn={cidn}
                productData={productData}
                key={productData.recommendedProductCode}
                subHeading={subHeading}
                displayCheckBox
              />
            ))
          }
        </div>
      </React.Fragment>
    );
    return (
      <div id={divId} className="business-case-builder row d-flex flex-column">
        <GenericCard
          headerTitle={heading}
          headerDescription={description}
          contentComponent={contentLayout}
        />
      </div>
    );
  }
}

export default BusinessCaseBuilderView;
